import { render } from "./SupportAssistance.vue?vue&type=template&id=30de346f&scoped=true"
import script from "./SupportAssistance.vue?vue&type=script&lang=js"
export * from "./SupportAssistance.vue?vue&type=script&lang=js"

import "./SupportAssistance.vue?vue&type=style&index=0&id=30de346f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30de346f"]])

export default __exports__